import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";


const enum fields {
    pardotUrl = "pardotUrl",
    piAId = "piAId",
    piCId = "piCId",
    piHostname = "piHostname",
}
interface Props extends WidgetProps {
    fields: {
        [fields.pardotUrl]: string;
        [fields.piAId]: string;
        [fields.piCId]: string;
        [fields.piHostname]: string;
    };
}

const Pardot: React.FC<Props> = ({ fields }) => {    

    useEffect(() => {
        (window as any).piAId = fields.piAId;
        (window as any).piCId = fields.piCId;
        (window as any).piHostname =  fields.piHostname;
        const script = document.createElement("script");
        script.type = 'text/javascript';
        script.src = (document.location.protocol === 'https:' ? 'https://pi' : 'http://cdn') + '.' + fields.pardotUrl;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return <><div id="pardotContainer"></div></>;
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.pardotUrl,
            displayName: "Pardot Url",
            editorTemplate: "TextField",
            defaultValue: "pardot.com/pd.js",
            fieldType: "General",
            tooltip: "Enter the pardot url",
        },
        {
            name: fields.piAId,
            displayName: "piAId",
            editorTemplate: "TextField",
            defaultValue: "938203",
            fieldType: "General"
        },
        {
            name: fields.piCId,
            displayName: "piCId",
            editorTemplate: "TextField",
            defaultValue: "73492",
            fieldType: "General"
        },
        {
            name: fields.piHostname,
            displayName: "piHostname",
            editorTemplate: "TextField",
            defaultValue: "pi.pardot.com",
            fieldType: "General"
        },
    ],
};

const widgetModule: WidgetModule = {
    component: Pardot,
    definition,
};

export default widgetModule;
